import { homeFinancialSDK } from "#sdk/sdk"
import type { FeatureFlags } from "@home-finance-manager/shared"
import { useQuery } from "@tanstack/react-query"

export function useFeatureFlags() {
  return useQuery<FeatureFlags>({
    queryKey: ["feature-flags"],
    queryFn: async () => {
      const response = await fetch(`${homeFinancialSDK.baseUrl}/feature-flags`)
      if (!response.ok) {
        throw new Error("Failed to fetch feature flags")
      }
      const { data } = await response.json()
      return data
    },
    staleTime: 5 * 60 * 1000, // Cache for 5 minutes
    retry: 1,
  })
}
